import styled from 'styled-components';
import { H2 } from '@rezdy/components/Heading';

export const Title = styled(H2)`
    /* margin: 0 0 16px; */
    font-weight: 900;
    line-height: 1.15;
    margin: 0;
    /* max-width: 12ch; */
`;
